/**
 * Unilar Oferta Relâmpago
 * Countdown timer for the flash sale section header.
 */

function parseOfertaRelampagoDate(value) {
  if (!value || !String(value).trim()) return null;

  const normalized = String(value).trim().replace(' ', 'T');
  const parsed = new Date(normalized).getTime();

  return Number.isNaN(parsed) ? null : parsed;
}

class OfertaRelampago {
  constructor(section) {
    this.section = section;
    this.scheduleWrapper = section.closest('unilar-scheduled-visibility');
    this.countdownEl = section.querySelector('[data-countdown]');
    this.endDate = parseOfertaRelampagoDate(section.dataset.countdownEnd);
    this.countdownInterval = null;
    this.handleScheduleChange = this.handleScheduleChange.bind(this);

    this.init();
  }

  init() {
    if (this.scheduleWrapper) {
      this.scheduleWrapper.addEventListener('unilar:scheduled-visibility-change', this.handleScheduleChange);
    }

    if (!this.isScheduledVisible()) {
      return;
    }

    this.showSection();
    this.refreshProductSlider();
    this.initCountdown();
  }

  isDesignMode() {
    return this.section.dataset.designMode === 'true' || Boolean(window.Shopify?.designMode);
  }

  isScheduledVisible() {
    if (this.isDesignMode() || !this.scheduleWrapper) return true;

    return this.scheduleWrapper.dataset.scheduledActive !== 'false' && !this.scheduleWrapper.hasAttribute('hidden');
  }

  handleScheduleChange(event) {
    if (event.detail?.visible) {
      this.showSection();
      this.refreshProductSlider();
      this.initCountdown();
      return;
    }

    this.stopCountdown();
  }

  showSection() {
    this.section.removeAttribute('hidden');
  }

  hideSection() {
    if (this.scheduleWrapper && !this.isDesignMode()) {
      this.scheduleWrapper.setAttribute('hidden', '');
      return;
    }

    if (!this.isDesignMode()) {
      this.section.setAttribute('hidden', '');
    }
  }

  initCountdown() {
    if (!this.countdownEl || !this.endDate) return;

    this.stopCountdown();

    const daysEl = this.countdownEl.querySelector('[data-countdown-days]');
    const hoursEl = this.countdownEl.querySelector('[data-countdown-hours]');
    const minutesEl = this.countdownEl.querySelector('[data-countdown-minutes]');
    const secondsEl = this.countdownEl.querySelector('[data-countdown-seconds]');

    const updateCountdown = () => {
      const distance = this.endDate - Date.now();

      if (distance <= 0) {
        if (daysEl) daysEl.textContent = '0';
        if (hoursEl) hoursEl.textContent = '0';
        if (minutesEl) minutesEl.textContent = '0';
        if (secondsEl) secondsEl.textContent = '0';

        if (!this.isDesignMode()) {
          this.hideSection();
        }

        this.stopCountdown();
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (daysEl) daysEl.textContent = String(days);
      if (hoursEl) hoursEl.textContent = String(hours);
      if (minutesEl) minutesEl.textContent = String(minutes);
      if (secondsEl) secondsEl.textContent = String(seconds);
    };

    updateCountdown();
    this.countdownInterval = setInterval(updateCountdown, 1000);
  }

  stopCountdown() {
    if (!this.countdownInterval) return;

    clearInterval(this.countdownInterval);
    this.countdownInterval = null;
  }

  refreshProductSlider() {
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        this.section.querySelectorAll('produtos-slider').forEach((slider) => {
          if (!(slider instanceof HTMLElement)) return;

          const carousel = slider.carousel;

          if (carousel && typeof carousel.updateMetrics === 'function') {
            carousel.updateMetrics();
          }
        });
      });
    });
  }
}

function initOfertaRelampagoSections() {
  document.querySelectorAll('[data-oferta-relampago]').forEach((section) => {
    if (!(section instanceof HTMLElement) || section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';
    new OfertaRelampago(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initOfertaRelampagoSections);
} else {
  initOfertaRelampagoSections();
}

if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', initOfertaRelampagoSections);
}
